/* eslint-disable @typescript-eslint/no-explicit-any */
import { gql, useQuery } from '@apollo/client';

// Seed the Map (Doge Spotters) - public momentum counts for the map chip. The
// backend resolver (spotMomentum, auth: false, 60s server-side cache) returns
// plain integers; any error (including the resolver not being deployed yet) is
// left to the caller, which degrades to a plain CTA - the chip must never
// break the map.
export const SPOT_MOMENTUM = gql`
  query spotMomentum {
    spotMomentum {
      weekCount
      liveCount
    }
  }
`;

export const useSpotMomentum = () => {
  const { data, loading, error } = useQuery(SPOT_MOMENTUM);
  const momentum = data?.spotMomentum;
  return {
    weekCount: (momentum?.weekCount || 0) as number,
    liveCount: (momentum?.liveCount || 0) as number,
    momentumLoading: loading,
    momentumError: error
  };
};
